<script>
import apiEndpoints from "@/services/apiEndpoints";
import sweetAlert from "@/mixins/sweetAlert";
import CommonTableComponent from "@/components/table.vue";
import tableSearch from "@/mixins/tableSearch";

export default {
  name: "commandStatus",
  components: {
    CommonTableComponent,
  },
  mixins: [sweetAlert, tableSearch],    
  props: {
    modalId: {
      type: String,
      default: 'modal-command-status'
    },
    commandType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      commandStatus: [],
      isLoading: false
    }
  },
  methods: {    
    async showStatuses(type) {
      this.commandType = type;
      await this.getData();
      this.$bvModal.show(this.modalId);
    },
    async getData() {
      this.isLoading = true;
      const sendApi = await this.$http.get(apiEndpoints.get_command_statuses,
        {
          params: {
          command_type: this.commandType
          }
        });
      const {status, data} = sendApi;
      if (status && data.result) {
        if (this.commandType === 'notifications') {
          this.commandStatus = data.result.filter(
            item => !['04', '07', '22'].includes(String(item.zz_top_message_id).padStart(2, '0'))
          );
        } else if (this.commandType === 'specialNotifications') {
          this.commandStatus = data.result.filter(
            item => ['04', '05', '07', '22'].includes(String(item.zz_top_message_id).padStart(2, '0'))
          );
        } else {
          this.commandStatus = data.result;
        }
      } else {
        this.commandStatus = [];
      }
      this.isLoading = false;
    },
    showStatuses(){
      this.$bvModal.show(this.modalId);
    },
 },
   computed: {
    headers() {
      return [
        {
          text: "",
          value: "",
          sortable: false,
        },
        {
          text: "処理名称",
          value: "create_user_name",
          sortable: false,
          width: 50,
        },
        {
          text: "最終実行",
          value: "work_order_name",
          sortable: false,
        },
      ];
    },
  }
}
</script>
<template>
  <div>
  <b-row class="mb-2">
    <b-col cols="8"></b-col>
    <b-col class="text-end">
    <p @click="showStatuses" style="text-decoration: underline;">
      取得状況確認
    </p>
    </b-col>
  </b-row>
  <div class="d-xl-flex">
    <b-modal
      :id="modalId"
      size="xl"
      centered
      title-class="font-18"
      body-class="p-20"
      hide-footer
      @show="getData"
    >
    <CommonTableComponent :height-class="`table-wrapper-500`" class="text-small">
        <thead class="table-light">
        <tr>
          <th
            :style="`width: ${item.width}`"
            v-for="(item, index) in headers"
            :key="index"
            :class="getHeaderClass(item)"
          >
            {{ item.text }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item , index) in commandStatus">
          <td></td>
          <td>{{ item.command_name }}</td>
          <td>{{ item.last_execution }}</td>
        </tr> 
      </tbody>
    </CommonTableComponent>
    </b-modal>
  </div>
  </div>
</template>
